module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_04_1280_1280_th-01d49e6040e88b58d2c793a74b154447.jpg";